import React from "react";
import image1 from "../../assests/project-2/project-2.1.png";
import image2 from "../../assests/project-2/project-2.2.png";
import image3 from "../../assests/project-2/project-2.3.png";
import image4 from "../../assests/project-2/project-2.4.png";
import image5 from "../../assests/project-2/project-2.5.png";

const ProjectDetails2 = () => {
  return (
    <section className="min-h-screen mx-6 lg:mx-20">
      <h3 className="text-4xl text-secondary text-center font-BebasNeue">
        Webster Car Warehouse
      </h3>
      <div className=" font-Poppins my-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <img src={image1} alt="banner" />
          <img src={image2} alt="review" />
          <img src={image3} alt="login" />
          <img src={image4} alt="order" />
          <img src={image5} alt="pay" />
        </div>
        <h5 className="text-2xl text-primary mt-4">Authentication</h5>
        <ul className="list-disc">
          <li>Firebase Authentication implemented.</li>
        </ul>
        <hr className="border-b-2 border-t-0 pt-2 border-neutral" />
        <h5 className="text-2xl text-primary mt-4">Other Features</h5>
        <ul className="list-disc">
          <li>
            There is update button on inventory items. clicking the button will
            take user to the <kbd>updateinventorydetail/:id</kbd> page
          </li>
          <li>
            After completing an order user can complete payment or delete an
            unpaid order on Dashboard - My Orders
          </li>
          <li>
            on the <kbd>updateinventorydetail/:id</kbd> page, clicking the
            delivery button will decrease the quantity of the inventory item
          </li>
          <li>
            Update button navigates to <kbd> updateinventorydetail/:id</kbd>{" "}
            page. Delete button deletes the item(car). Add To My Car takes to{" "}
            <kbd>addmycars/:id</kbd>
            page and makes another collection on database for storing myCars
            with user email.
          </li>
        </ul>

        <p>
          <a
            className="text-blue-600 hover:underline"
            target="_blank"
            rel="noreferrer"
            href="https://webster-car-warehouse.web.app/"
          >
            Live site
          </a>{" "}
          <br />
          <a
            className="text-blue-600 hover:underline"
            target="_blank"
            rel="noreferrer"
            href="https://github.com/ThakurSaad/webster-car-warehouse-frontend"
          >
            Frontend Code
          </a>
          <br />
          <a
            className="text-blue-600 hover:underline"
            target="_blank"
            rel="noreferrer"
            href="https://github.com/ThakurSaad/webster-car-warehouse-backend"
          >
            Backend Code
          </a>
        </p>
      </div>
    </section>
  );
};

export default ProjectDetails2;
